/**
 * Run a component's initialisation for the page and for every fragment htmx
 * inserts later
 *
 * Most components scan `document` once, when theme.js runs. Content that
 * htmx swaps in afterwards - the card an "Expand on click" listing opens
 * (@@booost-card-expand, docs/features/CARD_EXPAND.md), the entries a "load
 * more" button appends - would stay a dead `.gallery` or an unbuilt `.swiper`.
 * A component therefore writes its setup as `init(root)` and hands it here:
 *
 *   onFragment((root) => {
 *     within(root, '.gallery').forEach(setup)
 *   })
 *
 * `init(document)` runs right away; after that `init(elt)` for every element
 * htmx fires `htmx:load` on (each top-level node of a swap, and the body once
 * at htmx's own start). That event bubbles to the document, so this needs no
 * `window.htmx` at all - without htmx nothing is ever swapped in either.
 * `init` must be idempotent: the body's own `htmx:load` repeats the first
 * run, so every component marks the nodes it has set up and skips them.
 */

export const within = (root, selector) => {
  const found = Array.from(root.querySelectorAll(selector))
  if (root instanceof Element && root.matches(selector)) found.unshift(root)
  return found
}

export default (init) => {
  init(document)
  document.addEventListener('htmx:load', (e) => {
    if (e.target instanceof Element) init(e.target)
  })
}
